import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { Medal, Share2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { QuestHeroShare } from "@/components/quest/QuestHeroShare";
import { whenFree } from "@/lib/popupQueue";
import { confetti, playFanfare } from "@/lib/celebrate";

const KEY = "itz_quest_hero";

export function QuestHeroPopup({ q }) {
  const [open, setOpen] = useState(false);
  const [share, setShare] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const id = q?.my_hero && new Date(q.settled_at) > Date.now() - 7 * 86400000 ? q.id : null;
  useEffect(() => {
    if (!id || localStorage.getItem(`${KEY}_${id}`)) return;
    whenFree(`quest-hero-${id}`, () => {
      localStorage.setItem(`${KEY}_${id}`, "1");
      setOpen(true);
      playFanfare();
      [0, 350, 700].forEach((d, i) => setTimeout(() => confetti({ x: innerWidth * [0.5, 0.25, 0.75][i], y: innerHeight * 0.3, count: 100, spread: 1.8, colors: ["#fde68a", "#fbbf24", "#f59e0b", "#fff", "#ff1f4b"] }), d));
    });
  }, [id]);
  if (share) return <QuestHeroShare hero={{ quest_id: q.id, title: q.title, rank: q.my_hero, total: q.heroes.find((h) => h.rank === q.my_hero)?.total || 0 }} user={user} onClose={() => setShare(false)} />;
  if (!open) return null;
  const me = q.heroes.find((h) => h.rank === q.my_hero);
  const close = (go) => { setOpen(false); if (go) navigate("/profil"); };
  return createPortal(
    <div className="fixed inset-0 z-[85] flex items-center justify-center p-4 bg-black/75 backdrop-blur-sm wheel-fade" data-testid="quest-hero-popup">
      <div className="sky-celebrate w-full max-w-sm rounded-[2rem] p-6 text-center space-y-4 relative overflow-hidden bg-gradient-to-b from-amber-300 via-yellow-400 to-amber-600 text-amber-950 shadow-2xl shadow-amber-500/40">
        <span className="contest-shine" />
        <div className="relative mx-auto w-24 h-24 rounded-full bg-white/90 ring-8 ring-white/40 flex items-center justify-center shadow-xl"><Medal className="w-12 h-12 text-amber-500" /></div>
        <p className="relative text-xs font-extrabold uppercase tracking-[0.25em]">{q.title}</p>
        <p className="relative font-display text-4xl font-extrabold" data-testid="quest-hero-title">Aufgaben-Held!</p>
        <p className="relative text-sm font-semibold" data-testid="quest-hero-text">Platz {q.my_hero} der fleißigsten Helfer{me ? ` mit ${me.total} Beiträgen` : ""}. Dein goldenes Abzeichen glänzt jetzt in deinem Profil!</p>
        <button onClick={() => { setOpen(false); setShare(true); }} data-testid="quest-hero-share" className="relative w-full h-12 rounded-full bg-white text-amber-900 font-extrabold flex items-center justify-center gap-2"><Share2 className="w-4 h-4" /> Als Story teilen</button>
        <button onClick={() => close(true)} data-testid="quest-hero-profile" className="relative w-full h-12 rounded-full bg-amber-950 text-amber-100 font-extrabold">Abzeichen ansehen</button>
        <button onClick={() => close(false)} data-testid="quest-hero-ok" className="relative w-full text-sm font-bold">Schließen</button>
      </div>
    </div>,
    document.body
  );
}
